import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CompanyContext = createContext(undefined);

export function CompanyProvider({ children }) {
  const { user } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [companiesLoaded, setCompaniesLoaded] = useState(false);
  const [companyId, setCompanyId] = useState(() => localStorage.getItem("dad_company_id"));

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/companies");
      setCompanies(data);
      const stored = localStorage.getItem("dad_company_id");
      const valid = data.find((c) => c.company_id === stored);
      const pick = valid ? stored : data[0]?.company_id || null;
      if (pick) {
        localStorage.setItem("dad_company_id", pick);
        setCompanyId(pick);
      } else {
        localStorage.removeItem("dad_company_id");
        setCompanyId(null);
      }
      setCompaniesLoaded(true);
    } catch {
      setCompanies([]);
      setCompaniesLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (user) refresh();
    if (user === false) { setCompanies([]); setCompanyId(null); setCompaniesLoaded(false); localStorage.removeItem("dad_company_id"); }
  }, [user, refresh]);

  const switchCompany = (id) => {
    localStorage.setItem("dad_company_id", id);
    setCompanyId(id);
  };

  const company = companies.find((c) => c.company_id === companyId) || null;

  return (
    <CompanyContext.Provider value={{ companies, company, companyId, companiesLoaded, switchCompany, refresh }}>
      {children}
    </CompanyContext.Provider>
  );
}

export const useCompany = () => useContext(CompanyContext);
